const PRESS_EMAIL = 'partnerships@paw-champ.com'

const PRESS_POST_ROUTE_NAME = 'newsroom-slug'

const PRESS_SECTIONS: readonly string[] = ['press', 'press_post']

const PRESS_POSTS_PER_PAGE = 8

const PRESS_FEATURED_POSTS_LIMIT = 10

const PRESS_POST_SOURCES = {
  SEARCH: 'main_search',
  FEATURED: 'main_featured',
  EXPLORE: 'main_explore',
} as const

const PRESS_INQUIRY_TOPICS = [
  'press_inquiry',
  'interview_request',
  'media_kit',
  'partnership',
  'other',
] as const

const PRESS_INQUIRY_FIELDS = {
  EMAIL: 'email',
  MESSAGE: 'message',
} as const

const PRESS_INQUIRY_ERROR_TYPES = {
  REQUIRED_FIELD_EMPTY: 'required_field_empty',
  INVALID_EMAIL: 'invalid_email',
} as const

type PressPostSource = (typeof PRESS_POST_SOURCES)[keyof typeof PRESS_POST_SOURCES]

type PressInquiryTopic = (typeof PRESS_INQUIRY_TOPICS)[number]

type PressInquiryField = (typeof PRESS_INQUIRY_FIELDS)[keyof typeof PRESS_INQUIRY_FIELDS]

type PressInquiryErrorType =
  (typeof PRESS_INQUIRY_ERROR_TYPES)[keyof typeof PRESS_INQUIRY_ERROR_TYPES]

export {
  PRESS_EMAIL,
  PRESS_FEATURED_POSTS_LIMIT,
  PRESS_INQUIRY_ERROR_TYPES,
  PRESS_INQUIRY_FIELDS,
  PRESS_INQUIRY_TOPICS,
  PRESS_POST_ROUTE_NAME,
  PRESS_POST_SOURCES,
  PRESS_SECTIONS,
  PRESS_POSTS_PER_PAGE,
}

export type { PressInquiryErrorType, PressInquiryField, PressInquiryTopic, PressPostSource }
